import { Box } from "@mui/material";
import styles from "./style.module.css";
import Card from "./components/card";
import { useSelector } from "react-redux";
import DeleteConfirmation from "./components/delete-confirmation";

const Applications = () => {
  const {
    data: { applications },
  } = useSelector((state) => state.manageProjects);

  const renderProjects = applications?.map((project, index) => {
    return <Card project={project} key={index} />;
  });

  return (
    <Box className={styles.hosted}>
      <DeleteConfirmation />
      <Box className={styles.content}>{renderProjects}</Box>
    </Box>
  );
};

export default Applications;
